import { useState } from 'react';
import { AdminCatalogViewProduct } from '../../../api/types';
import { FILE_API_BASE_URL } from '../../../config/runtimeConfig';
import { ResponsiveImage } from '../../fileStorage/ResponsiveImage';

export function AdminProductImage({ product }: { product: AdminCatalogViewProduct }) {
  const [failedImageKey, setFailedImageKey] = useState<string>();
  const imageKey = `${product.image_file_id}:${product.image?.active_version ?? product.image?.variants[0]?.url ?? 'legacy'}`;
  if (product.image_file_id === null || product.image_file_id === undefined || failedImageKey === imageKey) {
    return (
      <div className="catalog-product-image catalog-product-image_empty">
        <span>{product.product_name.slice(0, 1).toUpperCase()}</span>
      </div>
    );
  }

  const imageUrl = new URL(`/v1/catalog-view/images/${product.image_file_id}`, FILE_API_BASE_URL);

  return (
    <div className="catalog-product-image">
      <ResponsiveImage image={product.image} alt={product.product_name} fallbackSrc={imageUrl.toString()} sizes="(max-width: 640px) 80px, 160px" onError={() => setFailedImageKey(imageKey)} />
    </div>
  );
}
